import React from 'react';
import { GridViewSharp, ViewListSharp } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const ViewToggle = ({ viewMode, setViewMode }) => {
  const { t } = useTranslation();

  return (
    <div className="job-view-toggle" role="group" aria-label="Job view layout">
      <button
        className={`${viewMode === 'grid' ? 'active' : ''}`}
        onClick={() => setViewMode('grid')}
        title={t('SearchJob.Grid view') || 'Grid view'}
        aria-pressed={viewMode === 'grid'}
        aria-label="Switch to grid view"
      >
        <GridViewSharp style={{ fontSize: '18px' }} />
        <span className="d-none d-sm-inline">{t('SearchJob.Grid') || 'Grid'}</span>
      </button>
      <button
        className={`${viewMode === 'list' ? 'active' : ''}`}
        onClick={() => setViewMode('list')}
        title={t('SearchJob.List view') || 'List view'}
        aria-pressed={viewMode === 'list'}
        aria-label="Switch to list view"
      >
        <ViewListSharp style={{ fontSize: '18px' }} />
        <span className="d-none d-sm-inline">{t('SearchJob.List') || 'List'}</span>
      </button>
    </div>
  );
};

export default ViewToggle;
